<div class="container">
	<ion-chip (click)="dismiss(false)" class="cross-icon">
		<ion-icon src="../../../assets/topgolf/close_hover.svg"></ion-icon>
	</ion-chip>
	<!-- <ion-icon src="../../../assets/topgolf/cross.svg" class="cross" (click)="dismiss(false)"></ion-icon> -->
	@if (title) {
		<h1 class="title">{{ title }}</h1>
	}
	@if (info) {
		<p class="info">{{ info }}</p>
	}
	@if (mainButton) {
		<div (click)="dismiss(true)" class="button button_main">
			{{ mainButton }}
		</div>
	}
	@if (closeButton) {
		<div (click)="dismiss(false)" class="button button_close">
			{{ closeButton }}
		</div>
	}
</div>
